<template>
  <div class="thecontainer">
    <CofocusLogo />
    <div class="linkname">
      <span class="rocky">🚀</span><span class="cofocusx">www.cofocus.one</span
      ><span class="rocky2">🚀</span>
    </div>
  </div>
</template>

<script>
import CofocusLogo from "./CofocusLogo";

export default {
  name: "DummyCofocus",
  components: {
    CofocusLogo,
  },
};
</script>

<style scoped>
.thecontainer {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-family: "F37 Ginger Regular", sans-serif;
}
.linkname {
  font-family: "F37 Ginger Regular", sans-serif;
  margin-top: 85px;
  font-size: 26px;
  color: #111;
}

.cofocusx {
  background: -webkit-linear-gradient(#000, #555);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  font-size: 28px;
}

.rocky {
  margin-right: 12px;
}
.rocky2 {
  margin-left: 12px;
}
</style>